var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank-item"},[_vm._t("rank-number"),_vm._t("product-name"),_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }